module.exports = __webpack_public_path__ + "img/Image-organic-shape.3dcd31ef.svg";